module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTg5NiIgaGVpZ2h0PSI2MjEiIHZpZXdCb3g9IjAgMCAxODk2IDYyMSI+PGRlZnM+PHBhdGggaWQ9Ijlva2phIiBkPSJNLTE3LjA5OCAxNDIxLjc4NHM1MjUuODE3IDMwMy44MjUgMTI4OS4zMzggMGM3NjMuNTItMzAzLjgyNiAwIDUyMS4wNiAwIDUyMS4wNnMtNjg5LjUzNS0xODcuMjYtMTI4OS4zMzggMGMtNTk5LjgwNCAxODcuMjYyIDAtNTIxLjA2IDAtNTIxLjA2eiIvPjwvZGVmcz48Zz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyODQgLTEzNTQpIj48dXNlIGZpbGw9IiNkY2VjZDgiIHhsaW5rOmhyZWY9IiM5b2tqYSIvPjwvZz48L2c+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/about-category-bg@dt.svg
// module id = t1OC
// module chunks = 2